export const sigmapGreen = {
  0: '#f2fbf7',
  50: '#d6f5e8',
  100: '#adebd1',
  200: '#7fdfb7',
  300: '#4dd39c',
  400: '#26c785',
  500: '#00A95C', // base color
  600: '#009653',
  700: '#007a44',
  800: '#005f35',
  900: '#004526',
  950: '#002b18',
};
